import filter from './filter';

/**
 * @returns {function}
 */
function keep() {
  return filter(function (x) {
    return x !== null && x !== undefined;
  });
}

export default keep;


// WEBPACK FOOTER //
// ./node_modules/lyjs/es/fp/keep.js